
import { useState } from 'react';

export default function CommercialFAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const faqs = [
    {
      question: 'Can you work around our business hours to minimise disruption?',
      answer:
        'Absolutely. We understand that downtime costs money. Our commercial teams regularly work after hours, weekends, and in phased stages to keep your business operational throughout the renovation process.',
    },
    {
      question: 'Do you handle all commercial building permits and compliance?',
      answer:
        'Yes. Tadashi Consulting manages all municipal approvals, occupancy certificates, fire compliance, and building regulation requirements. We ensure your commercial space meets all South African standards including SANS 10400 and local by‑laws.',
    },
    {
      question: 'What types of commercial properties do you renovate?',
      answer:
        'We handle offices, retail stores, restaurants, medical practices, wellness centres, hotels, warehouses, and mixed‑use developments across Johannesburg and greater Gauteng.',
    },
    {
      question: 'How do you ensure projects stay on budget?',
      answer:
        'We provide detailed, itemised quotations with fixed pricing on agreed scopes. Our project managers track costs daily and provide weekly financial reports. Any variations are discussed and approved before proceeding.',
    },
    {
      question: 'Do you offer design services or just construction?',
      answer:
        'Tadashi Consulting is a full‑service partner. We offer space planning, interior design, 3D visualisation, and construction management. We can also work with your existing architect or designer if preferred.',
    },
    {
      question: 'What warranty do you provide on commercial projects?',
      answer:
        'All commercial projects include a comprehensive workmanship warranty. Structural work carries a 10‑year warranty, mechanical and electrical installations are covered for 5 years, and finishes for 2 years.',
    },
  ];

  // Safety: ensure index is within bounds before accessing array
  const handleToggle = (index: number) => {
    setOpenIndex(prev => (prev === index ? null : index));
  };

  return (
    <section className="py-16 md:py-24 lg:py-28 bg-white">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-10 md:mb-16">
          <p className="text-xs font-semibold tracking-widest text-[#D4AF37] uppercase mb-4">
            Common Questions
          </p>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-[#2A2A2A] leading-tight">
            Commercial Construction{' '}
            <span className="font-serif text-[#D4AF37]">FAQ</span>
          </h2>
        </div>

        <div
          className="space-y-3 md:space-y-4"
          itemScope
          itemType="https://schema.org/FAQPage"
        >
          {faqs.map((faq, index) => (
            <article
              key={index}
              itemScope
              itemProp="mainEntity"
              itemType="https://schema.org/Question"
              className="border border-gray-200 rounded-xl md:rounded-2xl overflow-hidden"
            >
              <button
                onClick={() => handleToggle(index)}
                className="w-full flex items-center justify-between p-4 md:p-6 text-left cursor-pointer hover:bg-[#FDFBF7] transition-colors"
                aria-expanded={openIndex === index}
                aria-controls={`faq-answer-${index}`}
              >
                <h3
                  itemProp="name"
                  className="text-sm md:text-base font-semibold text-[#2A2A2A] pr-4"
                >
                  {faq.question}
                </h3>
                <div className="w-7 h-7 md:w-8 md:h-8 flex items-center justify-center flex-shrink-0">
                  <i
                    className={`ri-arrow-down-s-line text-lg md:text-xl text-[#D4AF37] transition-transform duration-300 ${
                      openIndex === index ? 'rotate-180' : ''
                    }`}
                    aria-hidden="true"
                  ></i>
                </div>
              </button>

              <div
                id={`faq-answer-${index}`}
                itemScope
                itemProp="acceptedAnswer"
                itemType="https://schema.org/Answer"
                className={`overflow-hidden transition-all duration-300 ${
                  openIndex === index ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
                }`}
              >
                <div className="px-4 md:px-6 pb-4 md:pb-6">
                  <p
                    itemProp="text"
                    className="text-xs md:text-sm text-gray-600 leading-relaxed"
                  >
                    {faq.answer}
                  </p>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
